export const projectSites = [
  {
    id: 1,
    name: "BOW",
    title:
      "Bayesian Optimization over Windows for Motion Planning in Complex Environments",
    venue: "IEEE Robotics and Automation Letters, 2025",
    desc: "A sample-efficient motion planner that uses constrained Bayesian optimization over local windows to guide robots safely through cluttered environments.",
    url: "https://bow-web.github.io/",
    tags: ["Bayesian Optimization", "Motion Planning", "Sample Efficiency"],
  },
  {
    id: 2,
    name: "BOWConnect",
    title:
      "Parallel Bayesian Optimization over Windows with Learned Local Cost Maps for Sample-Efficient Kinodynamic Motion Planning",
    venue: "IEEE/RSJ IROS, 2026",
    desc: "A bidirectional, parallel kinodynamic planner that pairs learned steering functions with Bayesian optimization to reach real-time planning performance.",
    url: "https://bow-connect.github.io/",
    tags: ["Kinodynamic Planning", "Learned Cost Maps", "Parallel Search"],
  },
  {
    id: 3,
    name: "STLcBOT",
    title:
      "Multi-Robot Trajectory Planning via Constrained Bayesian Optimization and Local Cost Map Learning with STL-Based Conflict Resolution",
    venue: "IEEE ICRA, 2026",
    desc: "A two-stage framework that combines sampling-based learning with Signal Temporal Logic reasoning to resolve conflicts in multi-robot motion planning under kinodynamic constraints.",
    url: "https://stlbot.github.io/",
    tags: ["Multi-Robot", "Signal Temporal Logic", "Conflict Resolution"],
  },
  {
    id: 4,
    name: "LCD-RIG",
    title:
      "Limited Communication Decentralized Robotic Information Gathering Systems",
    venue: "IEEE Robotics and Automation Letters, 2024",
    desc: "Decentralized scalar field mapping through pairwise communication, quadtree workspace decomposition, and Gaussian processes -- robot teams that keep learning when the network does not cooperate.",
    url: "https://lcd-rig.github.io/",
    tags: ["Decentralized Systems", "Gaussian Process", "Information Gathering"],
  },
  {
    id: 5,
    name: "DyConRIG",
    title: "Dynamic Consensus for Robotic Information Gathering",
    venue: "Under review, Robotics and Autonomous Systems",
    desc: "A distributed multi-robot system that uses consensus-based control to map environmental fields through coordinated, uncertainty-driven sampling.",
    url: "https://dyconrig.github.io/",
    tags: ["Consensus Control", "Distributed Systems", "Environmental Fields"],
  },
  {
    id: 6,
    name: "MRCPP",
    title:
      "Energy-Efficient Multi-Robot Coverage Path Planning of Non-Convex Regions of Interests",
    venue: "IEEE Robotics and Automation Letters, 2026",
    desc: "Energy-aware coverage paths for robot teams in large, non-convex, obstacle-filled areas, combining geometric optimization, graph connectivity, and workload-balanced task allocation.",
    url: "https://mrc-pp.github.io/",
    tags: ["Coverage Path Planning", "Energy Efficiency", "Task Allocation"],
  },
  {
    id: 7,
    name: "Localization via Environmental PDEs",
    title: "Localization in Spatiotemporal Fields via Environmental PDEs",
    venue: "IEEE/RSJ IROS, 2026",
    desc: "GPS-denied localization that matches onboard sensor readings against spatiotemporal fields predicted by environmental partial differential equations.",
    url: "https://localization-environmental-pdes.github.io/",
    tags: ["Localization", "GPS-Denied", "Spatiotemporal Fields"],
  },
];
